import React from "react";
import PropTypes from 'prop-types';
import TextField from "@material-ui/core/TextField";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

const SearchField = ({onChange, searchValue}) => {
    return (
        <>
            <TextField
                type={"string"}
                placeholder={'Search...'}
                onChange={onChange}
                value={searchValue}
                fullWidth
                autoFocus
                InputProps={{
                    endAdornment:
                        <IconButton size={"small"} onClick={() => onChange({target: {value: ""}})}>
                            <Icon fontSize={"small"}>
                                clear
                            </Icon>
                        </IconButton>
                }}
            />
        </>
    )
};
export default SearchField

SearchField.propTypes = {
    onChange: PropTypes.func,
    searchValue: PropTypes.string
};